import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { LambdaService } from 'src/app/lambda.service';
import { SettingsService } from 'src/app/settings.service';
import { ThemingService } from 'src/app/theming.service';
declare let $ : any;

@Component({
  selector: 'app-edit-client-subscription',
  templateUrl: './edit-client-subscription.component.html',
  styleUrls: ['./edit-client-subscription.component.scss']
})
export class EditClientSubscriptionComponent implements OnInit {

  loading = false;
  subscription = {
    clientSubscriptionName: ''
  }

  saveSubscription: boolean = false;

  @Input()
    subscriptionId!: string;

  constructor(
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private route: ActivatedRoute,
    public themingService: ThemingService,
    private settingsService: SettingsService,
    private lambdaService: LambdaService
  ) { }

  ngOnInit(): void {
    this.getClientSubscription(parseInt(this.subscriptionId),'')
  }

  changeSubscriptionName(event: Event) {
    const element = event.target as HTMLInputElement;
    this.subscription.clientSubscriptionName = element.value;
  }

  setListingSubscriptions(){
    this.settingsService.setListingSubscriptions();
  }

  async getClientSubscription(id: number, filter: string){
    try {
      const data: any = await this.lambdaService.getClientSubscriptionById(id, this.themingService.shopId);
      this.subscription = data.subscription;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  validateFormData(){
    this.loading = true;
    this.lambdaService.updateClientSubscription(
      this.themingService.shopId,
      parseInt(this.subscriptionId),
      this.subscription.clientSubscriptionName
    )
    .then((data: any) => {
      if(data.status === 200){
        $('#successSubscriptionModal').modal('show');
        this.loading = false;
      }
      else{
        $('#errorSubscriptionModal').modal('show');
        this.loading = false;
      }
    })
    .catch((error) => {
      console.error(error);
    });

    }

  resetForm() {
    this.subscription.clientSubscriptionName = '';
  }

  closeModal() {
    $('#successSubscriptionModal').modal('hide');
    $('#errorSubscriptionModal').modal('hide');
    $('#requiredSubscriptionModal').modal('hide');
    //this.resetForm();
    this.saveSubscription = false;
  }

}
